"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _server = _interopRequireDefault(require("react-dom/server"));
var _classnames = _interopRequireDefault(require("classnames"));
var _message = _interopRequireDefault(require("../../message/message"));
var _radio = _interopRequireDefault(require("../../inputs/radio/radio"));
var _SkeletonLoader = _interopRequireDefault(require("../../SkeletonLoader/SkeletonLoader"));
var _HelpSectionStageModule = _interopRequireDefault(require("./HelpSectionStage.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var HelpSectionStage = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var stepNumber = _ref.stepNumber,
    stageTitle = _ref.stageTitle,
    categories = _ref.categories,
    helpText = _ref.helpText,
    callback = _ref.callback,
    currentStep = _ref.currentStep,
    response = _ref.response,
    isResponse = _ref.isResponse;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  (0, _react.useEffect)(function () {
    setLoading(false);
  }, []);
  var verticalRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (verticalRef.current) {
      verticalRef.current.classList.remove(_HelpSectionStageModule["default"].animation);
      verticalRef.current.offsetHeight; // trigger reflow
      verticalRef.current.classList.add(_HelpSectionStageModule["default"].animation);
    }
  }, [stageTitle]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("fieldset", {
    className: (0, _classnames["default"])(_HelpSectionStageModule["default"].helpSectionStage, _defineProperty({}, _HelpSectionStageModule["default"].currentStep, currentStep === stepNumber + 1)),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _HelpSectionStageModule["default"].stepper,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _HelpSectionStageModule["default"].stepNumber,
        children: stepNumber + 1
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: verticalRef,
        className: _HelpSectionStageModule["default"].vertical
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _HelpSectionStageModule["default"].stageContent,
      id: ref ? 'scrollTarget' : undefined,
      ref: ref,
      children: [stageTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("legend", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          className: (0, _classnames["default"])(_defineProperty({}, _HelpSectionStageModule["default"].helpResponse, isResponse)),
          children: stageTitle
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _HelpSectionStageModule["default"].categories,
        children: categories && !isResponse && Object.keys(categories).map(function (category) {
          var thisCategory = categories[category];
          return loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonLoader["default"], {
            height: "54px"
          }, thisCategory.title) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_radio["default"], {
            checked: thisCategory.selected,
            label: thisCategory.title,
            name: "".concat(stepNumber, "_stepNumber"),
            value: thisCategory.id,
            inline: true,
            hasBorder: true,
            onChange: function onChange() {
              callback({
                selectedCategory: thisCategory,
                stepNumber: stepNumber
              });
            }
          }, thisCategory.title);
        })
      }), helpText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _HelpSectionStageModule["default"].message,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_message["default"], {
          title: "",
          htmlContent: _server["default"].renderToString(helpText),
          type: "jlm-light-green",
          icon: "help",
          style: "filled",
          size: "large"
        })
      }), isResponse && (response ? response : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _HelpSectionStageModule["default"].skeletonResponse,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonLoader["default"], {
          height: "56px"
        })
      }))]
    }, stepNumber)]
  });
});
HelpSectionStage.displayName = 'HelpSectionStage';
var _default = exports["default"] = HelpSectionStage; // The useState function is a React hook and is already imported at the top of the file.
// The placeholder implementation is unnecessary and can be removed.